<template>
	<el-dialog
		title="选择客户"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		append-to-body
		top="10vh"
		:visible.sync="dialogVisible"
		@close="closeDialog"
		width="1200px"
	>
		<div slot="title" class="flex align-center">
			<span class="iconfont-kehu"></span>
			<span class="margin-left-xs">选择客户</span>
		</div>
		<div class="flex justify-between padding-top">
			<el-form :inline="true" :model="formSearch" class="demo-form-inline" label-suffix=":">
				<el-form-item label="名称"><el-input v-model="formSearch.data.name" clearable placeholder="客户名称,支持模糊查询" style="width: 220px;"></el-input></el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getInfoList">
						<span class="el-icon-search"></span>
						查询
					</el-button>
				</el-form-item>
			</el-form>
			<div class="">
				<el-button type="success" round @click="addCustomer">
					<span class="el-icon-plus"></span>
					<span class="margin-left-xs">新建客户</span>
				</el-button>
			</div>
		</div>
		<div class="border">
			<el-table
				:data="tableData.infos"
				style="width: 100%"
				height="60vh"
				stripe
				v-loading="loading"
				element-loading-text="加载中..."
				element-loading-spinner="el-icon-loading"
			>
				<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
				<el-table-column prop="name" align="center" label="客户名称" min-width="250px">
					<template slot-scope="scope">
						<div class="text-blue text-bold text-left">{{ scope.row.name }}</div>
						<div class="text-grey text-left">{{ scope.row.credit_code }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="contacter" align="center" label="联系人">
					<template slot-scope="scope">
						<span v-if="scope.row.contacter">{{ scope.row.contacter.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type" align="center" label="类型">
					<template slot-scope="scope">
						<span v-if="scope.row.type == '公司'" class="cu-tag bg-blue radius">公司</span>
						<span v-else-if="scope.row.type == '个体'" class="cu-tag bg-cyan radius">个体</span>
						<span v-else class="cu-tag bg-gray radius">其他</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="业务" width="120">
					<template slot-scope="scope">
						<popover-user-card :userId="scope.row.salesman.user_id" :text="scope.row.salesman.name" v-if="scope.row.salesman"></popover-user-card>
					</template>
				</el-table-column>
				<el-table-column align="center" label="客服" width="120">
					<template slot-scope="scope">
						<popover-user-card :userId="scope.row.service.user_id" :text="scope.row.service.name" v-if="scope.row.service"></popover-user-card>
					</template>
				</el-table-column>
				<el-table-column prop="addtime" align="center" label="创建时间" width="180"></el-table-column>
				<el-table-column prop="name" align="center" label="选择" width="100">
					<template slot-scope="scope">
						<div class="text-green text-bold" v-if="customerInfo && customerInfo.id == scope.row.id">
							<i class="iconfont-xuanze"></i>
							<span>已选择</span>
						</div>
						<el-button size="small" type="primary" plain @click="checkCustomer(scope.row)" v-else>
							<span class="iconfont-xuanze"></span>
							选择
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="padding-top text-right">
			<el-pagination
				background
				@size-change="pageSizeChange"
				@current-change="pageChange"
				:current-page="tableData.page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="formSearch.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tableData.total"
			></el-pagination>
		</div>
	</el-dialog>
</template>

<script>
import popoverUserCard from '@/components/popover-user-card.vue';

export default {
	components: { popoverUserCard },
	name: 'check-contacter',
	props: {
		show: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		keyword: {
			type: String,
			default: () => {
				return '';
			}
		},
		current: {
			type: Object,
			default: () => {
				return null;
			}
		},
		config: {
			type: Object,
			default: () => {
				return { avatarSize: 128 };
			}
		}
	},
	data() {
		return {
			cfg: {},
			customer_id: '',
			errorMsg: '',
			dialogVisible: false,
			loading: false,
			formSearch: {
				page: 1,
				size: 10,
				data: {
					name: ''
				}
			},
			tableData: {
				total: 0,
				page: 1,
				size: 10,
				infos: []
			}
		};
	},
	created: function() {},
	mounted() {
		this.cfg = this.config;
		this.dialogVisible = this.show;
		this.customerInfo = this.current;
		this.formSearch.data.name = this.keyword;
	},
	methods: {
		getInfoList() {
			if (this.dialogVisible) {
				this.loading = true;
				this.$http.post('/server/index.php?m=components/checkCustomer&a=getCustomerList', this.formSearch).then(
					res => {
						this.loading = false;
						if (res.result == 'ok') {
							this.tableData = res.data;
						} else {
							this.$alert(res.msg, {
								title: '操作错误',
								type: 'error'
							});
						}
					},
					err => {
						this.loading = false;
						if (err) {
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					}
				);
			}
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getInfoList();
		},
		closeDialog() {
			this.$emit('close', true);
		},
		checkCustomer(data) {
			this.$emit('check', data);
			this.dialogVisible = false;
		},
		addCustomer() {
			this.$confirm('即将转到新页面进行客户创建, 是否继续?', '新建客户', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(
				r => {
					this.$router.push({ path: '/crm/customer/add' });
					console.log('r:', r);
				},
				e => {
					console.log('e:', e);
				}
			);
		}
	},
	watch: {
		show: function(d) {
			this.dialogVisible = d;
			if (this.tableData.infos.length == 0) {
				this.getInfoList();
			}
		},
		keyword: function(d) {
			this.formSearch.data.name = d;
			this.getInfoList();
		},
		current: function(d) {
			this.customerInfo = d;
		}
	}
};
</script>

<style>
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
